import React from 'react';
import { useTranslation } from 'react-i18next';
import Tip from '../Tip/Tip';
import styles from './sass/M1Tips.module.scss';

const TipFunctionalTrigger = () => {
  const { t } = useTranslation();

  return (
    <Tip
      styleTipTextContainer={`${styles.triggerContainer} ${styles.functionalContainer}`}
      styleTriangle={styles.triangle}
    >
      <p>
        {t('tipFunctionalTrigger')}
      </p>
    </Tip>
  );
};

export default TipFunctionalTrigger;
